<template>
  <v-layout row align-center px-1>
    <v-flex xs2 class="subheading font-weight-bold grey--text text-uppercase text-xs-right pr-2">{{paramTitle}}
    </v-flex>
    <v-flex xs6 class="pa-0 ma-0">
      <v-progress-linear
        height="20"
        background-opacity="0.5"
        v-model="Percents"
        :color="percentColor"        
        :class="{[`text-xs-center subheading font-weight-bold primary--text text--{darken}-{4} ma-2`]: true}"
        >{{Percents}}%</v-progress-linear>
    </v-flex>
    <v-flex xs5 class="caption font-weight-bold primary--text text-xs-right">{{bitrateCurr}} / {{bitrateMax}} {{dimmension}}
    </v-flex>
    
  </v-layout>
</template>
<script>
export default {
  name: "lineBitrate",
  props: {
    widthTitle: {
      type: Number,
      default: 20
    },
    widthBitrate: {
      type: Number,
      default: 160
    },
    widthDim: {
      type: Number,
      default: 100
    },
    bitrateCurr: {
      type: Number,
      required: true
    },
    bitrateMax: {
      type: Number,
      required: true
    },
    dimmension: {
      type: String,
      default: "mb/s"
    },
    paramTitle: {
      type: String,
      default: ""
    }
  },
  computed: {
    calcBRMaxWidth: function() {
      return this.widthBitrate - 5;
    },
    Percents: function() {
      if (this.bitrateMax > 0) 
      {

        var prcnt = Math.round((this.bitrateCurr * 100) / this.bitrateMax);
        if (prcnt>95)
          this.percentColor="secondary darken-1"
        else
          this.percentColor="secondary"
        return prcnt;
      } else 
      {
        return 0;
      }
    },
    calcBR: function() {
      var W = this.calcBRMaxWidth;
      var P = (this.Percents * W) / 100;
      if (P > W) P = W;
      return Math.round(P);
    }
  },
  data() {
    return {
      percentColor:"secondary"

    };
  }
};
</script>
